/* Cart updates use line keys, preserving different properties and selling plans. */
(function () {
  'use strict';
  if (window.SerlexCart) return;
  var configElement = document.getElementById('serlex-cart-config');
  if (!configElement) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  var cartUrl = config.cartUrl || '/cart', root = config.root || '/', busy = false, revision = 0;
  var lastCart = null;
  var money = function (cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style:'currency',currency:currency || config.currency || 'EUR'}).format(Number(cents || 0) / 100); }
    catch (_) { return (Number(cents || 0) / 100).toFixed(2); }
  };
  function node(tag, cls, text) { var el = document.createElement(tag); if (cls) el.className = cls; if (text != null) el.textContent = text; return el; }
  function safeURL(value, fallback) {
    try { var url = new URL(value, location.origin); return /^(https?:)$/.test(url.protocol) ? url.href : fallback; } catch (_) { return fallback; }
  }
  function link(text, href, cls) { var a = node('a', cls, text); a.href = safeURL(href, cartUrl); return a; }
  function status(text, error) {
    document.querySelectorAll('[data-sr-status],.sr-mini-status').forEach(function (el) { el.textContent = text; el.hidden = !text; el.dataset.error = String(!!error); });
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('serlex-cart-page,[data-sr-mini]').forEach(function (el) { el.setAttribute('aria-busy', String(value)); });
    document.querySelectorAll('[data-sr-qty],[data-sr-step],[data-sr-mini] button,.sr-cart-form button,.sr-cart-form textarea').forEach(function (el) { el.disabled = value; });
  }
  function updateCount(cart) {
    document.querySelectorAll('.cart-target .number').forEach(function (el) {
      el.replaceChildren(node('span','n-item',cart.item_count),node('span','sr-header-total',money(cart.total_price, cart.currency)));
    });
    document.querySelectorAll('.addcart-modal-subtotal').forEach(function (el) { el.textContent = 'Subtotal: ' + money(cart.total_price, cart.currency); });
  }
  function renderMini(cart) {
    lastCart = cart; revision++;
    updateCount(cart);
    document.querySelectorAll('#cart-info #cart-content').forEach(function (host) {
      var mini = node('div','sr-mini'); mini.dataset.srMini = '';
      var heading = node('div','sr-mini-heading'); heading.append(node('strong','','Your basket'),node('span','',cart.item_count + (cart.item_count === 1 ? ' item' : ' items'))); mini.append(heading);
      if (cart.items && cart.items.length) {
        var list = node('div','sr-mini-items');
        cart.items.forEach(function (item) {
          var row = node('article','sr-mini-line'), picture = link('',item.url,'sr-mini-image');
          var src = item.featured_image && item.featured_image.url || item.image;
          if (src) { var img = node('img'); img.src = safeURL(src,''); img.alt = item.product_title || item.title || ''; img.width = 96; img.height = 112; img.loading = 'lazy'; picture.append(img); }
          var info = node('div','sr-mini-info'); info.append(link(item.product_title || item.title,item.url,'sr-mini-title'));
          (item.options_with_values || []).forEach(function (option) { if (option.value !== 'Default Title') info.append(node('span','sr-mini-option',option.name + ': ' + option.value)); });
          if (item.selling_plan_allocation) info.append(node('span','sr-mini-option',item.selling_plan_allocation.selling_plan.name));
          Object.keys(item.properties || {}).forEach(function (key) { if (key[0] !== '_' && item.properties[key]) info.append(node('span','sr-mini-option',key + ': ' + item.properties[key])); });
          var pricing = node('div','sr-mini-price'); pricing.append(node('span','','Qty ' + item.quantity),node('strong','',money(item.final_line_price == null ? item.line_price : item.final_line_price,cart.currency))); info.append(pricing);
          var remove = node('button','sr-mini-remove','×'); remove.type = 'button'; remove.dataset.srRemove = item.key; remove.setAttribute('aria-label','Remove ' + (item.product_title || item.title));
          row.append(picture,info,remove); list.append(row);
        });
        mini.append(list);
        var total = node('div','sr-mini-total'); total.append(node('span','','Estimated total'),node('strong','',money(cart.total_price,cart.currency))); mini.append(total);
        mini.append(node('p','sr-mini-note','Shipping and any further discounts are calculated at checkout.'));
        mini.append(link('View basket & checkout →',cartUrl,'sr-primary'));
        mini.append(link('Continue shopping',config.shopUrl || root + 'collections/all','sr-mini-continue'));
      } else {
        mini.append(node('p','sr-mini-empty','Your basket is ready for something useful.'),link('Explore the shop ↗',config.shopUrl || root+'collections/all','sr-primary'));
      }
      var msg=node('p','sr-mini-status'); msg.setAttribute('role','status'); msg.hidden = true; mini.append(msg);
      host.replaceChildren(mini);
    });
  }
  function renderRegion(html) {
    var page = document.querySelector('serlex-cart-page'); if (!page) return;
    var old = page.querySelector('[data-sr-cart-region]');
    var fresh = new DOMParser().parseFromString(html || '', 'text/html').querySelector('[data-sr-cart-region]');
    if (!fresh || !old) throw new Error('Please refresh your basket to see the latest total.');
    var note = old.querySelector('[name=note]'), noteValue = note ? note.value : null, noteOpen = old.querySelector('.sr-cart-note')?.open;
    var terms = old.querySelector('[data-sr-terms]')?.checked;
    var focused = document.activeElement, oldRow = focused?.closest('[data-sr-line]');
    var focusKey = oldRow?.dataset.srLine, focusType = focused?.hasAttribute('data-sr-qty') ? 'qty' : focused?.dataset.srStep ? focused.dataset.srStep : 'remove';
    old.replaceWith(fresh);
    if (noteValue !== null && fresh.querySelector('[name=note]')) fresh.querySelector('[name=note]').value = noteValue;
    if (fresh.querySelector('.sr-cart-note')) fresh.querySelector('.sr-cart-note').open = !!noteOpen;
    if (fresh.querySelector('[data-sr-terms]')) fresh.querySelector('[data-sr-terms]').checked = !!terms;
    if (focusKey) {
      var row = Array.from(fresh.querySelectorAll('[data-sr-line]')).find(function (r) { return r.dataset.srLine === focusKey; });
      var target = row?.querySelector(focusType === 'qty' ? '[data-sr-qty]' : focusType === 'remove' ? '[data-sr-remove]' : '[data-sr-step="'+focusType+'"]');
      if (!target) target = fresh.querySelector('[data-sr-qty],.sr-primary');
      target?.focus({preventScroll:true});
    }
  }
  async function readJSON(url, options) {
    var response = await fetch(url, Object.assign({credentials:'same-origin',headers:{'Accept':'application/json'}},options));
    var data = await response.json();
    if (!response.ok) {
      var text = data.description || data.message || data.errors;
      if (text && typeof text === 'object') text = Object.values(text).flat().join(' ');
      var error = new Error(typeof text === 'string' ? text : 'We could not update your basket. Please try again.'); error.cartRejected = true; throw error;
    }
    return data;
  }
  async function refreshRegion() {
    var page = document.querySelector('serlex-cart-page'); if (!page) return;
    var id = page.dataset.section;
    var sections = await readJSON(cartUrl + '?sections=' + encodeURIComponent(id));
    renderRegion(sections[id]);
  }
  async function change(key, qty) {
    if (busy || !Number.isInteger(qty) || qty < 0) return;
    var page = document.querySelector('serlex-cart-page'), section = page?.dataset.section;
    var data = {id:key,quantity:qty}; if (section) { data.sections = [section]; data.sections_url = cartUrl; }
    setBusy(true); status('Updating your basket…');
    try {
      var cart = await readJSON(cartUrl + '/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
      if (section) renderRegion(cart.sections && cart.sections[section]);
      renderMini(cart); status('Basket updated.');
    } catch (error) {
      // A lost response may follow a successful write: re-read instead of retrying the mutation.
      try { await refreshRegion(); var latest = await readJSON(cartUrl+'.js'); renderMini(latest); status(error.message,true); }
      catch (_) { status('Please refresh this page before checkout so your basket and total are up to date.',true); document.querySelectorAll('.sr-checkout').forEach(function(el){el.dataset.srBlocked='true';}); }
    } finally {
      setBusy(false);
      document.querySelectorAll('[data-sr-blocked]').forEach(function(el){el.disabled=true;});
    }
  }
  function quantity(input, direction) {
    var increment=Number(input.step)||1, minimum=Number(input.dataset.min)||1, current=Number(input.value), value=direction ? current+direction*increment : current;
    if (value>0 && value<minimum) value = direction<0 ? 0 : minimum;
    if (!Number.isInteger(value) || value<0 || (value>0 && value%increment!==0) || (input.max && value>Number(input.max))) {
      input.value=input.dataset.current; status('Please use the permitted quantity for this item.',true); return;
    }
    if(value!==Number(input.dataset.current)) change(input.closest('[data-sr-line]').dataset.srLine,value);
  }
  document.addEventListener('click', function(event) {
    var mini = event.target.closest('[data-sr-mini]'); if (mini) event.stopPropagation();
    var remove = event.target.closest('[data-sr-remove]');
    if(remove) {event.preventDefault();change(remove.dataset.srRemove,0);return;}
    var step = event.target.closest('[data-sr-step]');
    if(step) {event.preventDefault();quantity(step.parentNode.querySelector('[data-sr-qty]'),Number(step.dataset.srStep));return;}
    var basket = event.target.closest('.cart-target > .basket.dropdown-toggle');
    if(basket) {
      event.preventDefault();event.stopPropagation();var holder=basket.parentElement;holder.classList.remove('sr-cart-dismissed');holder.classList.toggle('opened');basket.setAttribute('aria-expanded',String(holder.classList.contains('opened')));
    }
  },true);
  document.addEventListener('change',function(event){if(event.target.matches('[data-sr-qty]'))quantity(event.target,0);});
  document.addEventListener('submit',function(event){
    if(event.target.matches('[data-sr-cart-form]')) {
      if(busy || event.target.querySelector('[data-sr-blocked]')) {event.preventDefault();return;}
      // Native Shopify form handles Update and Checkout, including the order note and no-JS use.
    }
  });
  document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('.cart-target').forEach(function(holder){if(holder.contains(document.activeElement))holder.querySelector('.basket')?.focus();holder.classList.remove('opened');holder.classList.add('sr-cart-dismissed');holder.querySelector('.basket')?.setAttribute('aria-expanded','false');});});
  document.querySelectorAll('.cart-target').forEach(function(holder){holder.addEventListener('mouseenter',function(){holder.classList.remove('sr-cart-dismissed');holder.querySelector('.basket')?.setAttribute('aria-expanded','true');});holder.addEventListener('mouseleave',function(){if(!holder.classList.contains('opened'))holder.querySelector('.basket')?.setAttribute('aria-expanded','false');});});
  window.Shopify=window.Shopify||{};
  window.updateCartDesc=updateCount;
  window.Shopify.updateCartInfo=renderMini;
  window.Shopify.onCartUpdate=renderMini;
  window.SerlexCart={render:renderMini,change:change};
  var initialRevision=revision;
  readJSON(cartUrl+'.js').then(function(cart){if(revision===initialRevision)renderMini(cart);}).catch(function(){document.querySelectorAll('#cart-info #cart-content').forEach(function(host){host.replaceChildren(link('View your basket →',cartUrl,'sr-primary'));});});
})();
